import { u as useAdminTRPC } from './trpc-2b4d7b2f.esm.js';

function useAccountByUuid(params, options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['accounts.getByUuid', params], options);
}

function useAccountManagers(options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['employees.getAccountManagers'], options);
}

function useProducers(options) {
  const {
    useQuery
  } = useAdminTRPC();
  return useQuery(['employees.getProducers'], options);
}

export { useAccountManagers as a, useProducers as b, useAccountByUuid as u };
